<script>
import { useEventBus } from "@thegetty-private/getty-ui";

export default {
  name: "DownloadMixin",

  data() {
    return {
      /**
       * Event bus composable instance
       */
      eventBus: useEventBus()
    };
  },
  methods: {
    /**
     * This method appends a link to a document and clicks it
     * for downloading within the browser and sends a
     * download event to analytics system
     *
     * @param {document} HTML Document
     * @param {url} imageURL - the Image URL
     * @param {String} objectId - The HumanMadeObject ID
     * @param {String} qualifier - extra qualifier
     */
    downloadImage(document, imageUrl, objectId, qualifier) {
      let link = document.createElement("a");
      link.href = imageUrl;
      document.body.appendChild(link);
      link.click();

      this.eventBus.emit("AnalyticsEvent", {
        action: "Image Download",
        category: `Image Download (largest available) ${qualifier}`,
        label: objectId,
        noninteraction: true
      });
    }
  }
};
</script>
